import { extendTheme, type ThemeConfig } from '@chakra-ui/react';

const config: ThemeConfig = {
  initialColorMode: 'dark',
  useSystemColorMode: false,
};

const theme = extendTheme({
  config,
  colors: {
    oxygon: {
      primary: '#00F6FF',
      secondary: '#7000FF',
      accent: '#FF0099',
      dark: {
        100: '#1A1A1A',
        200: '#222222',
        300: '#333333',
        400: '#444444',
      }
    }
  },
  styles: {
    global: {
      body: {
        bg: 'oxygon.dark.100',
        color: 'white',
      }
    }
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: 'md',
        _hover: {
          transform: 'translateY(-2px)',
          transition: 'all 0.2s',
        }
      },
      variants: {
        primary: {
          bg: 'oxygon.primary',
          color: 'black',
          _hover: {
            bg: 'oxygon.primary',
            opacity: 0.9,
          }
        },
        secondary: {
          bg: 'oxygon.secondary',
          color: 'white',
          _hover: {
            bg: 'oxygon.secondary',
            opacity: 0.9,
          }
        }
      }
    }
  }
});

export default theme;
